<template>
  <v-card>
    <v-card-title primary-title>{{ $t('custom_wording') }}</v-card-title>
    <v-list v-if="value.length > 0">
      <v-list-tile v-for="(item, itemIndex) in value" :key="itemIndex">
        <v-list-tile-avatar>
          <span v-html="`{{${itemIndex + 1}}}`"></span>
        </v-list-tile-avatar>
        <v-list-tile-content class="form-control">
          <input
            type="text"
            :value="item"
            class="ma-0"
            @input="handleTextInput(itemIndex, $event.target.value)"
          />
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon flat color="error" @click="handleDelete(itemIndex)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-card-actions>
      <v-btn outline color="primary" @click="handleAdd">
        <v-icon>add</v-icon>
        {{ $t('Add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleAdd() {
      this.$emit('input', [...this.value, ''])
    },
    handleDelete(index) {
      this.$emit(
        'input',
        this.value.filter((item, itemIndex) => itemIndex !== index)
      )
    },
    handleTextInput(index, value) {
      this.$emit(
        'input',
        this.value.map((item, itemIndex) => {
          if (itemIndex === index) {
            return value
          }
          return item
        })
      )
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/facebook-template/CustomWording.vue